<template>
  <div>
    <v-card v-if="!loadingStalled" :loading="loading" outlined>
      <v-card-title class="subtitle-2"> Design Details </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container>
          <v-row justify="center" align-content="center">
            <v-col cols="12">
              <span class="font-weight-black"> Design Description</span> :
              <span v-html="designBreakdown"></span>
            </v-col>
          </v-row>
          <v-row justify="center" align-content="center">
            <v-col
              cols="auto"
              v-for="config in designConfiguration"
              :key="config.label"
            >
              <span class="font-weight-black"> {{ config.label }}</span> :
              <br />
              {{ config.text }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { nodeRestApi } from '../plugins/api';
import { dateFormatLocal } from '../plugins/date';
export default {
  name: 'design-description',
  props: {
    deviceType: {
      type: String,
      required: true
    },
    deviceId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      deviceConfigurationRaw: {},
      designBreakdown: '',
      loading: false,
      loadingStalled: false
    };
  },
  computed: {
    designConfiguration() {
      return [
        {
          label: 'Design Code',
          text: this.deviceConfigurationRaw.designcode
            ? this.deviceConfigurationRaw.designcode
            : 'N/A'
        },
        {
          label: 'Software V',
          text: this.deviceConfigurationRaw.softwareversion
            ? this.deviceConfigurationRaw.softwareversion
            : 'N/A'
        },
        {
          label: 'PCB Serial',
          text: this.deviceConfigurationRaw.pcbserial
            ? this.deviceConfigurationRaw.pcbserial
            : 'N/A'
        },
        {
          label: 'Drive Serial',
          text: this.deviceConfigurationRaw.driveserial
            ? this.deviceConfigurationRaw.driveserial
            : 'N/A'
        },
        {
          label: 'Drive Firmware',
          text: this.deviceConfigurationRaw.drivefirmwarever
            ? this.deviceConfigurationRaw.drivefirmwarever
            : 'N/A'
        },
        {
          label: 'Drive Parameter',
          text: this.deviceConfigurationRaw.driveparamver
            ? this.deviceConfigurationRaw.driveparamver
            : 'N/A'
        },
        {
          label: 'ICCID',
          text: this.deviceConfigurationRaw.simserial
            ? this.deviceConfigurationRaw.simserial
            : 'N/A'
        },
        {
          label: 'Mobile',
          text: this.deviceConfigurationRaw.simnumber
            ? this.deviceConfigurationRaw.simnumber
            : 'N/A'
        },
        {
          label: 'APN',
          text: this.deviceConfigurationRaw.apn
            ? this.deviceConfigurationRaw.apn
            : 'N/A'
        },
        {
          label: 'Microconttoller',
          text: this.deviceConfigurationRaw.microcontroller
            ? this.deviceConfigurationRaw.microcontroller
            : 'N/A'
        },
        {
          label: 'SPD Serial',
          text: this.deviceConfigurationRaw.spdserial
            ? this.deviceConfigurationRaw.spdserial
            : 'N/A'
        },
        {
          label: 'Production V',
          text: this.deviceConfigurationRaw.productionversion
            ? this.deviceConfigurationRaw.productionversion
            : 'N/A'
        },
        {
          label: 'EcoGen Verison',
          text: this.deviceConfigurationRaw.ecogenversion
            ? this.deviceConfigurationRaw.ecogenversion
            : 'N/A'
        },
        {
          label: 'Process ID',
          text: this.deviceConfigurationRaw.tranzact
            ? this.deviceConfigurationRaw.tranzact
            : 'N/A'
        },
        {
          label: 'QC Ticket',
          text: this.deviceConfigurationRaw.qcticket
            ? this.deviceConfigurationRaw.qcticket
            : 'N/A'
        },
        {
          label: 'Invoice',
          text: this.deviceConfigurationRaw.invoice
            ? this.deviceConfigurationRaw.invoice
            : 'N/A'
        },
        {
          label: 'Approval Time',
          text: this.deviceConfigurationRaw.approvalstagetime
            ? dateFormatLocal(this.deviceConfigurationRaw.approvalstagetime)
            : ''
        }
      ];
    }
  },
  async created() {
    try {
      //set loading on
      this.loading = true;
      // geting maching configuration
      const response = await nodeRestApi.get(
        `${this.deviceType}/design-metrics/${this.deviceId}`
      );
      this.designBreakdown = response.data.designBreakDown;
      this.deviceConfigurationRaw = response.data.deviceConfig;
      // console.log(response.data)
      // set loading off
    } catch (error) {
      //set loading off
      this.loadingStalled = true;
      if (error.isAxiosError && error.response) {
        this.$store.commit('setError', error.response.data.error.message);
      } else {
        this.$store.commit('setError', error.message);
      }
    } finally {
      //set loading off
      this.loading = false;
    }
  }
};
</script>

<style></style>
